import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantRoleDatastreamComponent } from '../tenant-role-datastream/tenant-role-datastream.component';
import { TenantRoleMdmComponent } from '../tenant-role-mdm/tenant-role-mdm.component';
import { TenantRoleImmunityComponent } from '../tenant-role-immunity/tenant-role-immunity.component';

type RoleService = 'datastream' | 'immunity' | 'mdm';

@Component({
  selector: 'app-tenant-role',
  imports: [TenantRoleDatastreamComponent, TenantRoleMdmComponent, TenantRoleImmunityComponent],
  templateUrl: './tenant-role.component.html',
  styleUrl: './tenant-role.component.scss'
})
export class TenantRoleComponent {
  private slug: string;

  services: { key: RoleService; label: string; icon: string }[] = [
    { key: 'datastream', label: 'Datastream GUI', icon: 'bi-grid-1x2-fill' },
    { key: 'immunity', label: 'Immunity Bio', icon: 'bi-shield-check' },
    { key: 'mdm', label: 'MDM', icon: 'bi-diagram-3-fill' }
  ];

  selectedService: RoleService = 'datastream';

  constructor(private route: ActivatedRoute, private router: Router) {
    this.slug = this.route.snapshot.paramMap.get('slug') ?? '';
  }

  goBack(): void {
    this.router.navigate(['/tenants', this.slug]);
  }

  selectService(key: RoleService): void {
    this.selectedService = key;
  }
}
